import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';
import styles from './styles.scss';
import { joinClassNames } from '../../../../utils';

type PriorityHighIconProps = Omit<BaseIconProps, 'children'>;

export const PriorityHighIcon = ({ className, ...props }: PriorityHighIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={false}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    className={joinClassNames(styles.priorityHighIcon, className)}
    {...props}
  >
    <rect x="0.5" y="0.788086" width="16" height="16" rx="2" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.49997 4.78809C8.2032 4.78809 7.92175 4.91991 7.73175 5.1479L2.73175 11.1479C2.37819 11.5722 2.43551 12.2027 2.85979 12.5563C3.28407 12.9099 3.91463 12.8525 4.2682 12.4283L8.49997 7.35014L12.7318 12.4283C13.0853 12.8525 13.7159 12.9099 14.1402 12.5563C14.5644 12.2027 14.6218 11.5722 14.2682 11.1479L9.2682 5.1479C9.0782 4.91991 8.79675 4.78809 8.49997 4.78809Z"
    />
  </BaseIcon>
);

PriorityHighIcon.displayName = 'PriorityHighIcon';
